module.exports = __webpack_public_path__ + "img/Screenshot_from_2022-09-05_20-34-50.7ccaa07b.png";